exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.half-width[data-v-c85a5b80] {\n    width: 35%;\n}\n.table-transparency[data-v-c85a5b80] {\n    background-color: rgba(0,0,0,0);\n}\n", ""]);

// exports
